import { useEffect, useState } from "react";
import "../Common/css/styles.css";
import { getAttendanceRecords } from "src/Services/attendance_api";
import { Divider } from "@mui/material";

export default function Attendance() {
    const [record, setRecord] = useState<any>(null);
    const [selectedDay, setSelectedDay] = useState<any>(null);

    // Calendar month state
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

    const userId = sessionStorage.getItem("userId") || "";
    const token = sessionStorage.getItem("token") || "";

    const handleGetAttendanceRecords = async () => {
        try {
            const res = await getAttendanceRecords(token, userId);
            setRecord(res);
        } catch (error) {
            setRecord(null);
        }
    };

    useEffect(() => {
        handleGetAttendanceRecords();
    }, []);

    if (!record) return <div className="attendance-wrapper">Loading...</div>;

    const attendance = record.attendanceRecords || [];

    // Filter attendance for visible month
    const filteredAttendance = attendance.filter((item: any) => {
        const d = new Date(item.date);
        return d.getMonth() === currentMonth && d.getFullYear() === currentYear;
    });

    // Map attendance by date
    const attendanceMap = filteredAttendance.reduce((map: any, item: any) => {
        const dateKey = item.date.split("T")[0];
        if (!map[dateKey]) map[dateKey] = [];
        map[dateKey].push(item);
        return map;
    }, {});

    // Calendar generation
    const firstDay = new Date(currentYear, currentMonth, 1).getDay();
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

    const datesArray = [];
    for (let i = 0; i < firstDay; i++) datesArray.push(null);
    for (let i = 1; i <= daysInMonth; i++) datesArray.push(i);

    const monthName = new Date(currentYear, currentMonth).toLocaleString("default", { month: "long" });

    // Month Navigation
    const goToPrevMonth = () => {
        if (currentMonth === 0) {
            setCurrentMonth(11);
            setCurrentYear(currentYear - 1);
        } else {
            setCurrentMonth(currentMonth - 1);
        }
        setSelectedDay(null);
    };

    const goToNextMonth = () => {
        if (currentMonth === 11) {
            setCurrentMonth(0);
            setCurrentYear(currentYear + 1);
        } else {
            setCurrentMonth(currentMonth + 1);
        }
        setSelectedDay(null);
    };

    return (
        <div className="attendance-wrapper">

            {/* Month Controller */}
            <div className="attendance-header">
                <button className="attendance-nav-btn" onClick={goToPrevMonth}>←</button>
                <h2 className="attendance-title">{monthName} {currentYear}</h2>
                <button className="attendance-nav-btn" onClick={goToNextMonth}>→</button>
            </div>

            <div className="attendance-calendar">
                {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
                    <div key={d} className="attendance-day-header">{d}</div>
                ))}

                {datesArray.map((day, index) => {
                    const dateKey = day
                        ? `${currentYear}-${String(currentMonth + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`
                        : "";

                    const att = attendanceMap[dateKey];

                    const statusClass =
                        att && att.length > 0
                            ? (att[0].isAttend ? "attendance-present" : "attendance-present")
                            : "";

                    return (
                        <div
                            key={index}
                            className={`attendance-day-cell ${statusClass}`}
                            onClick={() => att && setSelectedDay(att)}
                        >
                            {day}
                        </div>
                    );
                })}
            </div>

            {selectedDay && (
                <div className="attendance-details">
                    <h3>Attendance Details</h3>

                    <Divider style={{margin: "10px 0", background: "#747272ff"}}/>

                    {selectedDay.map((rec: any) => (
                        <div key={rec.id} className="attendance-detail-item">
                            <p><strong>Date:</strong> {rec.date.split("T")[0]} - {rec.date.split("T")[1]}</p>
                            <p><strong>Subject:</strong> {rec.subjectName === "Unknown" ? rec.stream : rec.subjectName}</p>
                            <p>
                                <strong>Status:</strong>{" "}
                                <span className={rec.isAttend ? "attendance-present-text" : "attendance-absent-text"}>
                                    {rec.isAttend ? "Present" : "Absent"}
                                </span>
                            </p>
                            <Divider style={{margin: "10px 0", background: "#747272ff"}}/>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
